export const func = {
  mode: "zh",
  func: {
    title: "SEL-DI 帮您找寻最适合 ‘产品’ 的销售与营销方法。",
    description: `销售&营销过程中，逐渐贴合自身
    ‘专属于我的出口方法’`,
    one: "客制分析",
    two: "配对服务",
    three: "销售优化",
    button: "申请",
  },
};
